/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { BrokerProfileLinkResponseDtoLabel } from './brokerProfileLinkResponseDtoLabel';
import type { BrokerProfileLinkResponseDtoType } from './brokerProfileLinkResponseDtoType';

export interface BrokerProfileLinkResponseDto {
  id: string;
  type: BrokerProfileLinkResponseDtoType;
  url: string;
  /** @nullable */
  label: BrokerProfileLinkResponseDtoLabel;
}
